export class Localizzazione {
    latitude: number;
    longitude: number;
    indirizzo: string;
    dataAcquisizione: Date;
    userGpsLocation: boolean;
}
